import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { YoutubePlayerComponent } from '../youtube-player/youtube-player.component';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { IPopup } from './popup.model';
import { BaseComponent } from '../../Pages/base.component';
import { CommonModule } from '@angular/common';
import { SchoolApiService } from '../../Services/schoolApi.service';
import { UrlDetectorPipe } from '../../Services/urlDetector.pipe';

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    YoutubePlayerComponent,
    CommonModule,
    UrlDetectorPipe,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupComponent extends BaseComponent {
  public data: IPopup;
  constructor(
    @Inject(MAT_DIALOG_DATA) articleData: IPopup,
    schoolApiService: SchoolApiService
  ) {
    super(schoolApiService);
    this.data = articleData;
  }
}
